import React from "react";
import { IconsProps } from "./Icons";

export const TopicsIconDash = ({
  className,
  fill,
  width,
  height,
  viewBox,
}: IconsProps) => {
  return (
    <svg
      className={className}
      width={width || "40"}
      height={height || "40"}
      viewBox={viewBox || "0 0 40 40"}
      fill={fill || "None"}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 32.5H28C29.0609 32.5 30.0783 32.0786 30.8284 31.3284C31.5786 30.5783 32 29.5609 32 28.5V11.1667C32 10.1058 31.5786 9.08839 30.8284 8.33824C30.0783 7.58809 29.0609 7.16667 28 7.16667H22.6667V4.5C22.6667 3.43913 22.2452 2.42172 21.4951 1.67157C20.7449 0.921427 19.7275 0.5 18.6667 0.5H13.3333C12.2725 0.5 11.2551 0.921427 10.5049 1.67157C9.75476 2.42172 9.33333 3.43913 9.33333 4.5V7.16667H4C2.93913 7.16667 1.92172 7.58809 1.17157 8.33824C0.421427 9.08839 0 10.1058 0 11.1667V28.5C0 29.5609 0.421427 30.5783 1.17157 31.3284C1.92172 32.0786 2.93913 32.5 4 32.5ZM28 29.8333H4C3.64638 29.8333 3.30724 29.6929 3.05719 29.4428C2.80714 29.1928 2.66667 28.8536 2.66667 28.5V19.1667H12V23.1667C12 23.5203 12.1405 23.8594 12.3905 24.1095C12.6406 24.3595 12.9797 24.5 13.3333 24.5H18.6667C19.0203 24.5 19.3594 24.3595 19.6095 24.1095C19.8595 23.8594 20 23.5203 20 23.1667V19.1667H29.3333V28.5C29.3333 28.8536 29.1929 29.1928 28.9428 29.4428C28.6928 29.6929 28.3536 29.8333 28 29.8333ZM14.6667 19.1667H17.3333V21.8333H14.6667V19.1667ZM12 4.5C12 4.14638 12.1405 3.80724 12.3905 3.55719C12.6406 3.30714 12.9797 3.16667 13.3333 3.16667H18.6667C19.0203 3.16667 19.3594 3.30714 19.6095 3.55719C19.8595 3.80724 20 4.14638 20 4.5V7.16667H12V4.5ZM4 9.83333H28C28.3536 9.83333 28.6928 9.97381 28.9428 10.2239C29.1929 10.4739 29.3333 10.813 29.3333 11.1667V16.5H2.66667V11.1667C2.66667 10.813 2.80714 10.4739 3.05719 10.2239C3.30724 9.97381 3.64638 9.83333 4 9.83333Z"
        fill="#F77803"
      />
    </svg>
  );
};
